import { render, staticRenderFns } from "./RelatedForms.vue?vue&type=template&id=4dcc4019"
import script from "./RelatedForms.vue?vue&type=script&lang=js"
export * from "./RelatedForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports